// extracted by mini-css-extract-plugin
module.exports = {"ModalBody":"EditModal__ModalBody___zp_0q"};